<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title=" Kawalan Kualiti Semen Beku">
      <div class="table_scrol">
        <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt4">
              <div class="xs6">
                <div class="spacer"></div>
                <div class="spacer"></div>
                 <w-input style="margin:5px; "
                 v-model="pencarian.no_batch"
                 label="No. Batch"
                 />
              </div>
              <div class="xs4">
                <div class="spacer"></div>
                 <z-select style="margin:5px; "
                 v-model="pencarian.se_katalog_id"
                 :items="se_katalog"
                 label="ID | Nama Ternakan"
                 />
              </div>
              <div class="xs4">
                 <z-select style="margin:5px; "
                 v-model="pencarian.lkp_status_id"
                 :items="status"
                 label="Status"
                 />
              </div>
            </w-flex>
          </w-form>

          <w-flex justify-end class="mt2">
                      <w-button bg-color="success" v-on="on" @click="cetak()" class="mr2">
                    <w-icon class="mr1" md >fal fa-print</w-icon>CETAK
                </w-button>
                      <w-button class="mr2" v-on:click="resetPencarian()" v-on="on" bg-color="warning">
                    <w-icon class="mr1" md >fal fa-redo</w-icon>SET SEMULA
                </w-button>
                      <w-button class="mr2" bg-color="primary"  v-on="on" @click="$refs.frm.validate()">
                    <w-icon class="mr1" md >fal fa-search</w-icon>CARI
                </w-button>
          </w-flex>
        </div>
  		  <z-table title="Senarai Kawalan Kualiti Semen Beku" :headers="table.headers" :items="table.items" :meta="table.meta">
          
            <template #button v-if="$zutil.anyRole(['1', '3', '11'])">
                      <inertia-link :href="$route('se.kawalan.show',0)" v-on="on" class="w-button green--bg  w-button--dark size--md  ml1"> 
                    <w-icon class="mr1" md >fal fa-plus</w-icon>TAMBAH
                </inertia-link>
            </template>
  		    <template #header-label="{ header, label, index }">
  		      <template v-if="header.key == 'action'">
  			     <!--  <w-icon xs>fal fa-pencil</w-icon> -->
             TINDAKAN
            </template>
  		      <template v-else>
  		      	{{ label }}
  		      </template>
  		    </template>
          <template #item-cell.status="{ item, label, header, index }">
            <template v-if="item.status_memeriksaan_id == 25">
              <w-button class="ma1" bg-color="success" round>Penilaian Kualiti : {{item.status_memeriksaan}}</w-button>
            </template>
            <template v-if="item.status_memeriksaan_id == 24">
              <w-button class="ma1" bg-color="error" round>Penilaian Kualiti : {{item.status_memeriksaan}}</w-button>
            </template>
            <template v-if="item.status_kemandirian_id == 25">
              <w-button class="ma1" bg-color="success" round>Ujian Kemandirian : {{item.status_kemandirian}}</w-button>
            </template>
            <template v-if="item.status_kemandirian_id == 24">
              <w-button class="ma1" bg-color="error" round>Ujian Kemandirian : {{item.status_kemandirian}}</w-button>
            </template>
            <template v-if="item.status_penyakit_id == 25">
              <w-button class="ma1" bg-color="success" round>Ujian Saringan Penyakit : {{item.status_penyakit}}</w-button>
            </template>
            <template v-if="item.status_penyakit_id == 24">
              <w-button class="ma1" bg-color="error" round>Ujian Saringan Penyakit : {{item.status_penyakit}}</w-button>
            </template>
          </template>
          <template #item-cell.status_kawalan="{ item, label, header, index }">
            <template v-if="item.status_kawalan_id == 25">
              <w-button class="ma1" bg-color="success" round> {{item.status_kawalan}}</w-button>
            </template>
            <template v-if="item.status_kawalan_id == 24">
              <w-button class="ma1" bg-color="error" round> {{item.status_kawalan}}</w-button>
            </template>
          </template>
  		    <template #item-cell.action="{ item, label, header, index }">
              <w-flex class="flex justify-center">
                <inertia-link :href="$route('se.kawalan.show',item.id)" class="w-button w-button--dark size--md info-dark1--bg"> 
                <w-icon xs class="mr2">fal fa-eye</w-icon>  PAPAR
                </inertia-link>
                <template v-if="$zutil.anyRole(['1', '3', '11'])">
                   &nbsp;
                  <w-button  bg-color="warning" v-if="item.hantar==0" :route="$route('se.kawalan.show',item.id)" class="be fs-2">
                    <w-icon xs class="mr2">fal fa-pencil</w-icon> KEMASKINI 
                  </w-button>
                  &nbsp;
                  <w-button class="fs-2" v-if="item.pakai==0" bg-color="error-dark1" dark tile @click="destroy1(item.id)">
                  <w-icon xs class="mr2">fal fa-trash</w-icon> PADAM
                </w-button>
                </template>
              </w-flex>
            </template>
  		  </z-table>
      </div>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.katalog',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Kawalan Kualiti Semen Beku', route: '/se/kawalan' },
      ],
      pencarian: {
         no_batch: '',
         se_katalog_id: '',
         lkp_status_id: ''
      },
      se_katalog: [],
      status: [],
    }
  },
  methods: {
   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },
    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },
    getKatalog(){
      this.$zcomm.get(this.api_service + 'lookup/id_ternakan_se', {}).then(res => {
        this.se_katalog = res
      })
    },
    cetak() {
      window.location.href = window.route('se.kawalan.index')+'?se_katalog_id='+this.pencarian.se_katalog_id+'&no_batch='+this.pencarian.no_batch+'&lkp_status_id='+this.pencarian.lkp_status_id+'&cetak=1';
    },

    destroy1(id)
    {
      this.$swal({
        title: 'Anda Pasti?',
        // text: "Are you sure want to delete this item!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete(this.resourceurl + '.destroy',id)
          .then(res => {
            this.sending = false;
            this.$inertia.visit(this.$page.url)
            this.removeitem(res) // remove the data from list. no need to refresh page
            if (typeof this.onAfterDelete === "function") {
              this.onAfterDelete()
            }
          })
          .finally(() => {
            // $('#' + this.resourceurl).modal('hide')
          });
        }else{ }
        })

    },

    edit() {
          this.form = idx;
          this.form.saveButton = "Kemaskini";
          this.dialog.show = true
      },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_mp', {}).then(res => {
         this.status = res
      })
    },
  
  },

  watch: {

  },
  mounted() {
   this.getStatus();
   this.getKatalog();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
